<template>
	<div class="search-user-profit">
		<div class="el-search vue-top-padding radius">
			<el-row :gutter="20">
				<el-col :span="3">
					<div class="el-left">
						<el-button
							size="small"
							icon="el-icon-printer"
							@click="exportOrder"
							>{{ $t("common.export") }}</el-button
						>
					</div>
				</el-col>
				<el-col :span="21">
					<div class="el-right">
						<el-form
							ref="order"
							:model="search"
							:inline="true"
							label-width="10px"
							size="small"
							class="demo-form-inline el-input-height"
						>
							<el-form-item>
								<el-date-picker
									v-model="dateTime"
									type="daterange"
									format="yyyy-MM-dd"
									value-format="yyyy-MM-dd"
									range-separator="-"
									:picker-options="pickerOptions"
									:start-placeholder="$t('searchUserProfit.start')"
									:end-placeholder="$t('searchUserProfit.end')"
								>
								</el-date-picker>
							</el-form-item>
							<el-form-item>
								<el-input
									v-model="search.userName"
									:placeholder="$t('searchUserProfit.userName')"
								></el-input>
							</el-form-item>
							<el-form-item>
								<el-button
									type="primary"
									@click="onSubmit"
									icon="el-icon-search"
									>{{ $t("common.search") }}</el-button
								>
								<el-button
									@click="resetSearch('order')"
									icon="el-icon-refresh"
									>{{ $t("common.reset") }}</el-button
								>
							</el-form-item>
						</el-form>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchUserProfit",
	props: {
		search: Object,
	},
	data() {
		return {
			pickerOptions: {
				shortcuts: [
					{
						text: this.$t("TimeControl.week"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.month"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.year"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit("pick", [start, end]);
						},
					},
				],
			},
			dateTime: "",
		};
	},
	methods: {
		onSubmit() {
			if (this.dateTime && this.dateTime.length > 0) {
				this.search.startDate = this.dateTime[0];
				this.search.endDate = this.dateTime[1];
			}
			this.$emit("onSubmit", this.search);
		},
		resetSearch(formName) {
			this.$refs[formName].resetFields(); // 这个只是清除了表单数据，对象并没有重新赋值，所以调用下面的方法赋空值
			this.$toolUtil.clearForm(this.search);
			this.dateTime = "";
			this.$emit("resetSearch", this.search);
		},
		exportOrder() {
			this.$confirm(this.$t("searchUserProfit.export"), this.$t("common.tip"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			})
				.then(() => {
					this.$notify({
						title: this.$t("common.tip"),
						icon: "warning",
						message: this.$t("common.exportloading"),
						position: "bottom-right",
						type: "warning",
					});
					this.$api.download(this.$url.Statistics.exportUser, this.search);
				})
				.catch(err => {
					this.$message.error(err.msg);
				});
		},
	},
};
</script>

<style scoped></style>
